const FormResources = {

    form_data:{
        description:            '',
        include_days_off:       true,
        include_assignment:     true,
        include_census:         true,
        include_qc:             true,
    },

    form_format:[
        
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include In Days Off:',
            model_name: 'include_days_off',
            ref:        'include_days_off_input',
            ref_alt:    'include_days_off_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include In Assignment:',
            model_name: 'include_assignment',
            ref:        'include_assignment_input',
            ref_alt:    'include_assignment_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include In Census:',
            model_name: 'include_census',
            ref:        'include_census_input',
            ref_alt:    'include_census_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include In Q.C:',
            model_name: 'include_qc',
            ref:        'include_qc_input',
            ref_alt:    'include_qc_input_alt',
            required:   false,
        },
    ]

}

export default FormResources;